import React, { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const AppContext = createContext({})

export function AppProvider({ children }) {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null) // JSON de la AI
  const [userState, setUserState] = useState(null) // starea din DB
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) loadUserData(session.user.id)
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
      if (session?.user) loadUserData(session.user.id)
      else { setProfile(null); setUserState(null); setLoading(false) }
    })

    return () => subscription.unsubscribe()
  }, [])

  async function loadUserData(userId) {
    try {
      const { data } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('user_id', userId)
        .single()

      if (data) {
        setProfile(data.ai_profil)
        setUserState(data)
      }
    } catch (e) {
      console.error('loadUserData error:', e)
    } finally {
      setLoading(false)
    }
  }

  async function saveUserProfile(aiProfil) {
    const { data, error } = await supabase
      .from('user_profiles')
      .upsert({
        user_id: user.id,
        ai_profil: aiProfil,
        onboarding_completat: true,
        updated_at: new Date().toISOString(),
      })
      .select()
      .single()

    if (!error) {
      setProfile(aiProfil)
      setUserState(data)
    }
    return { data, error }
  }

  async function saveZiluaDeAzi(ziData) {
    const today = new Date().toISOString().split('T')[0]
    const { data: existing } = await supabase
      .from('progres_zilnic')
      .select('id')
      .eq('user_id', user.id)
      .eq('data', today)
      .single()

    if (existing) {
      return supabase.from('progres_zilnic').update(ziData).eq('id', existing.id)
    } else {
      return supabase.from('progres_zilnic').insert({ user_id: user.id, data: today, ...ziData })
    }
  }

  async function signUp(email, password) {
    return supabase.auth.signUp({ email, password, options: { emailRedirectTo: undefined } })
  }

  async function signIn(email, password) {
    return supabase.auth.signInWithPassword({ email, password })
  }

  async function signOut() {
    await supabase.auth.signOut()
    setProfile(null)
    setUserState(null)
  }

  const hasOnboarding = !!profile
  const hasPaid = userState?.has_paid === true
  const trialActive = userState?.trial_activ === true

  return (
    <AppContext.Provider value={{
      user, profile, userState, loading,
      hasOnboarding, hasPaid, trialActive,
      signUp, signIn, signOut,
      saveUserProfile, saveZiluaDeAzi, loadUserData,
    }}>
      {children}
    </AppContext.Provider>
  )
}

export const useApp = () => useContext(AppContext)
